export default __webpack_public_path__ + "static/path-light-4731e4c5bcf2087c41905027e59a8379.png";